import useScrollToBottom from './useScrollToBottom';

export default useScrollToBottom;
